// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/img/stars.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-mcq-work-exp-t-logo {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 20px;
  left: 20px;
  right: 123px;
  bottom: 123px;
}

.new-mcq-work-exp-btn-wrapper {
  margin-top: 24px;
}

.new-mcq-work-exp-btn {
  background: #00000029 0% 0% no-repeat padding-box !important;
  border-radius: 4px !important;
  opacity: 1 !important;
  text-align: left !important;
  font-size: 14px !important;
  font-weight: 500;
  letter-spacing: 0.56px !important;
  color: #FFFFFF !important;
}

.btn-icon {
  margin-left: 12px !important;
  margin-top: 5px;
}

.new-allow-card-click {
  cursor: pointer;
}

.new-mcq-work-exp-card {
  background: transparent linear-gradient(255deg, #56A8F7 0%, #6C7BD4 100%) 0% 0% no-repeat padding-box !important;
  box-shadow: 0 0 24px #0000000A;
  border-radius: 8px;
  opacity: 1;
  min-height: 259px !important;
  height: auto;
  width: 100%;
  max-width: 964px;
  padding-bottom: 24px;
}

.new-mcq-work-exp-card .ant-card-body {
  padding: 0 !important;
  padding-left: 40px !important;
  display: flex;
  /* justify-content: space-between; */
}

.new-mcq-work-exp-description-wrapper {
  max-width: 520px;
  /* height: 69px; */
  margin-top: 24px;
}

.star-bullet-list-item {
  list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.15px;
}

.disc-bullet-list-item {
  list-style-type: disc !important;

  font-size: 14px;
  letter-spacing: 0.15px;
  margin-bottom: 5px !important;
}

.expand-description {
  max-width: calc(100% - 290px) !important;
}

.new-mcq-work-exp-description {
  text-align: left;
  font-size: 16px;

  letter-spacing: 0;
  color: #FFFFFF !important;
  opacity: 1;
}

.new-mcq-work-exp-est-time-wrapper {
  position: relative;
  top: 10px;
  left: 20px
}

.new-mcq-work-exp-est-time-wrapper-new {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: space-evenly;
  height: 100%;
  min-height: 100%;
}

.new-mcq-work-exp-est-time-wrapper-new:hover {
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.24);
}

.est-time-text-small {
  color: #2E6EDF;

  font-size: 12px;
  line-height: 17px;
}

.est-time-text-medium {
  color: #2E6EDF;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
}

.est-time-hr {
  width: 90%;
  margin: 0 auto;
}

.est-time-button {
  color: #2E6EDF !important;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.25px;
  margin: auto;
}

.est-time-button-icon {
  vertical-align: middle;
  margin-left: 10px;
}

.new-mcq-work-exp-est-time-text {
  height: 22px;
  text-align: left;
  font-size: 14px;

  letter-spacing: 0;
  color: #888888;
  opacity: 1;
}

.new-mcq-work-exp-text {
  height: 104px;
  text-align: left;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  color: #888888;
  opacity: 1;
}

.new-mcq-work-exp-est-time {
  height: 26px;
  text-align: left;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  color: #888888;
  opacity: 1;
}

.modal-cand-name {
  margin-top: 27px;
  height: 16px;
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.96px;
  color: #FFAE3B;
  text-transform: uppercase;
  opacity: 1;
  text-align: center;
}

.modal-title-wrapper {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  text-align: center;
}

.test-modal-title-wrapper {
  margin-top: 0;
  display: flex;
  flex-direction: column;
  text-align: center;
}

.modal-title-wrapper_small {
  height: 19px;
  line-height: 19px;
  font-size: 14px;

  letter-spacing: 0;
  color: #888888;
  opacity: 1;
}

.modal-title-wrapper_header {
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 20px;
  margin-top: 8px;
  font-weight: 500;
  letter-spacing: 0;
  color: #212121;
  opacity: 1;
}

.test-modal-title-wrapper_header {
  height: 30px;
  line-height: 30px;
  text-align: left;
  font-size: 20px;
  margin-top: 4.4px;
  font-weight: 500;
  letter-spacing: 0.25px;
  color: #212121;
  opacity: 1;
}

.modal-description {
  margin-top: 32px;
  height: 271px;
  line-height: 23px !important;
  text-align: left;
  font-size: 14px;

  letter-spacing: 0;
  color: #444444;
  opacity: 1;
}

.test-modal-description {
  margin-top: 8px;
  line-height: 22px !important;
  text-align: left;
  font-size: 14px;

  letter-spacing: 0.15px;
  color: #212121;
  opacity: 1;
}

.test-modal-description-text {
  margin-bottom: 20px;
}

.modal-button-wrapper {
  margin-top: 40px;
  height: 36px;
  text-align: center;
}

.modal-button {
  background: #333333 0% 0% no-repeat padding-box !important;
  box-shadow: 0 2px 4px #00000014 !important;
  border-radius: 4px !important;
  opacity: 1 !important;
}

.test-modal-button-wrapper {
  margin-top: 40px;
  height: 36px;
  text-align: right;
}

.test-modal-button {
  background: #2E6EDF 0% 0% no-repeat padding-box !important;
  padding: 10px 16px !important;
  box-shadow: 0 2px 4px #00000014 !important;
  border-radius: 6px !important;
  opacity: 1 !important;
}

.ant-btn.ant-btn-primary.test-modal-button:active {
  background-color: #10316A !important;
  padding: 10px 16px !important;
  box-shadow: 0 2px 4px #00000014 !important;
  border-radius: 6px !important;
  opacity: 1 !important;
}

.test-modal-button-link {
  display: inline !important;
  margin-right: 8px;
  color: #2E6EDF !important;
  padding: 10px 16px !important;
  opacity: 1 !important;
}

.test-modal-button-link:hover {
  display: inline !important;
  background-color: #DCE6FA !important;
  margin-right: 8px;
  color: #2E6EDF !important;
  padding: 10px 16px !important;
  opacity: 1 !important;
}

.test-modal-column-wrapper {
  display: grid;
  grid-template-columns: 51px auto;
}

.image-wrapper {
  display: inline;
}

.column-description-wrapper { 
  display: inline;
  margin-left: 13px; 
  vertical-align: top;
}

.column-description-title { 
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.15px;
  height: 22px;
  color: #212121;
}

.column-description-text {

  font-size: 12;
  color: #212121;
}

.modal-cup-img {
  width: 58px;
  height: 58px;
}

.modal-cup-wrapper {
  margin: 0 auto;
  opacity: 1;
  text-align: center;
}

.modal-illustration-img {
  width: 255px;
  height: 255px;
}

.modal-illustration-wrapper {
  margin: 0 auto;
  opacity: 1;
  text-align: center;
}

.new-work-exp-time-wrapper {
  position: absolute;
  width: 175px;
  height: 175px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0 0 20px #0000000A;
  border-radius: 8px;
  opacity: 1;
  top: 40px;
  /* left: 232px; */
  right: 48px;
  bottom: 44px
}

.new-work-exp-time-wrapper-new {
  position: absolute;
  width: 30%;
  max-width: 294px;
  /* height: 175px; */
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0 0 20px #0000000A;
  border-radius: 6px;
  opacity: 1;
  top: 32px;
  /* left: 232px; */
  right: 32px;
  bottom: 32px
}

.new-mcq-work-exp-title-small {
  height: 26px;
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.15px;
  color: #FFFFFF !important;
  opacity: 1;
}

.new-mcq-work-exp-title {
  height: 37px;
  text-align: left;
  font-size: 28px;
  font-weight: 500;
  letter-spacing: 0;
  color: #FFFFFF !important;
  opacity: 1;
}

.new-mcq-work-exp-title-wrapper {
  margin-top: 32px !important;
  width: 70%;
  max-width: 520px;
}

.shrink-title {
  max-width: calc(100% - 175px - 54px);
}

@media only screen and (min-width: 1201px) and (max-width: 1310px) {
  .new-mcq-work-exp-card .ant-card-body {
    height: 350px
  }
  .new-mcq-work-exp-btn-wrapper {
    margin-top: 0;
    position: absolute;
    bottom: 32px;
  }
  .new-mcq-description-wrapper-div {
    width: 60%
  }
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/workExperience/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4DAA4D;EAC5D,6BAA6B;EAC7B,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gHAAgH;EAChH,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;EACzD,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;;EAEhC,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,eAAe;;EAEf,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;;EAEf,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;;EAEf,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;;EAEf,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;;EAEf,sBAAsB;EACtB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;EAC1D,0CAA0C;EAC1C,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0DAA0D;EAC1D,6BAA6B;EAC7B,0CAA0C;EAC1C,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,0CAA0C;EAC1C,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,+CAA+C;EAC/C,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,+CAA+C;EAC/C,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE;EACF;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,YAAY;EACd;EACA;IACE;EACF;AACF","sourcesContent":[".new-mcq-work-exp-t-logo {\n  width: 32px;\n  height: 32px;\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  right: 123px;\n  bottom: 123px;\n}\n\n.new-mcq-work-exp-btn-wrapper {\n  margin-top: 24px;\n}\n\n.new-mcq-work-exp-btn {\n  background: #00000029 0% 0% no-repeat padding-box !important;\n  border-radius: 4px !important;\n  opacity: 1 !important;\n  text-align: left !important;\n  font-size: 14px !important;\n  font-weight: 500;\n  letter-spacing: 0.56px !important;\n  color: #FFFFFF !important;\n}\n\n.btn-icon {\n  margin-left: 12px !important;\n  margin-top: 5px;\n}\n\n.new-allow-card-click {\n  cursor: pointer;\n}\n\n.new-mcq-work-exp-card {\n  background: transparent linear-gradient(255deg, #56A8F7 0%, #6C7BD4 100%) 0% 0% no-repeat padding-box !important;\n  box-shadow: 0 0 24px #0000000A;\n  border-radius: 8px;\n  opacity: 1;\n  min-height: 259px !important;\n  height: auto;\n  width: 100%;\n  max-width: 964px;\n  padding-bottom: 24px;\n}\n\n.new-mcq-work-exp-card .ant-card-body {\n  padding: 0 !important;\n  padding-left: 40px !important;\n  display: flex;\n  /* justify-content: space-between; */\n}\n\n.new-mcq-work-exp-description-wrapper {\n  max-width: 520px;\n  /* height: 69px; */\n  margin-top: 24px;\n}\n\n.star-bullet-list-item {\n  list-style-image: url('../../../../assets/img/stars.png');\n  font-weight: 500;\n  font-size: 14px;\n  letter-spacing: 0.15px;\n}\n\n.disc-bullet-list-item {\n  list-style-type: disc !important;\n\n  font-size: 14px;\n  letter-spacing: 0.15px;\n  margin-bottom: 5px !important;\n}\n\n.expand-description {\n  max-width: calc(100% - 290px) !important;\n}\n\n.new-mcq-work-exp-description {\n  text-align: left;\n  font-size: 16px;\n\n  letter-spacing: 0;\n  color: #FFFFFF !important;\n  opacity: 1;\n}\n\n.new-mcq-work-exp-est-time-wrapper {\n  position: relative;\n  top: 10px;\n  left: 20px\n}\n\n.new-mcq-work-exp-est-time-wrapper-new {\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  justify-content: space-evenly;\n  height: 100%;\n  min-height: 100%;\n}\n\n.new-mcq-work-exp-est-time-wrapper-new:hover {\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.24);\n}\n\n.est-time-text-small {\n  color: #2E6EDF;\n\n  font-size: 12px;\n  line-height: 17px;\n}\n\n.est-time-text-medium {\n  color: #2E6EDF;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 27px;\n  letter-spacing: 0.15px;\n}\n\n.est-time-hr {\n  width: 90%;\n  margin: 0 auto;\n}\n\n.est-time-button {\n  color: #2E6EDF !important;\n  font-weight: 500;\n  font-size: 20px;\n  letter-spacing: 0.25px;\n  margin: auto;\n}\n\n.est-time-button-icon {\n  vertical-align: middle;\n  margin-left: 10px;\n}\n\n.new-mcq-work-exp-est-time-text {\n  height: 22px;\n  text-align: left;\n  font-size: 14px;\n\n  letter-spacing: 0;\n  color: #888888;\n  opacity: 1;\n}\n\n.new-mcq-work-exp-text {\n  height: 104px;\n  text-align: left;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  color: #888888;\n  opacity: 1;\n}\n\n.new-mcq-work-exp-est-time {\n  height: 26px;\n  text-align: left;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  color: #888888;\n  opacity: 1;\n}\n\n.modal-cand-name {\n  margin-top: 27px;\n  height: 16px;\n  font-weight: 500;\n  font-size: 12px;\n  letter-spacing: 0.96px;\n  color: #FFAE3B;\n  text-transform: uppercase;\n  opacity: 1;\n  text-align: center;\n}\n\n.modal-title-wrapper {\n  margin-top: 24px;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n}\n\n.test-modal-title-wrapper {\n  margin-top: 0;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n}\n\n.modal-title-wrapper_small {\n  height: 19px;\n  line-height: 19px;\n  font-size: 14px;\n\n  letter-spacing: 0;\n  color: #888888;\n  opacity: 1;\n}\n\n.modal-title-wrapper_header {\n  height: 26px;\n  line-height: 26px;\n  text-align: center;\n  font-size: 20px;\n  margin-top: 8px;\n  font-weight: 500;\n  letter-spacing: 0;\n  color: #212121;\n  opacity: 1;\n}\n\n.test-modal-title-wrapper_header {\n  height: 30px;\n  line-height: 30px;\n  text-align: left;\n  font-size: 20px;\n  margin-top: 4.4px;\n  font-weight: 500;\n  letter-spacing: 0.25px;\n  color: #212121;\n  opacity: 1;\n}\n\n.modal-description {\n  margin-top: 32px;\n  height: 271px;\n  line-height: 23px !important;\n  text-align: left;\n  font-size: 14px;\n\n  letter-spacing: 0;\n  color: #444444;\n  opacity: 1;\n}\n\n.test-modal-description {\n  margin-top: 8px;\n  line-height: 22px !important;\n  text-align: left;\n  font-size: 14px;\n\n  letter-spacing: 0.15px;\n  color: #212121;\n  opacity: 1;\n}\n\n.test-modal-description-text {\n  margin-bottom: 20px;\n}\n\n.modal-button-wrapper {\n  margin-top: 40px;\n  height: 36px;\n  text-align: center;\n}\n\n.modal-button {\n  background: #333333 0% 0% no-repeat padding-box !important;\n  box-shadow: 0 2px 4px #00000014 !important;\n  border-radius: 4px !important;\n  opacity: 1 !important;\n}\n\n.test-modal-button-wrapper {\n  margin-top: 40px;\n  height: 36px;\n  text-align: right;\n}\n\n.test-modal-button {\n  background: #2E6EDF 0% 0% no-repeat padding-box !important;\n  padding: 10px 16px !important;\n  box-shadow: 0 2px 4px #00000014 !important;\n  border-radius: 6px !important;\n  opacity: 1 !important;\n}\n\n.ant-btn.ant-btn-primary.test-modal-button:active {\n  background-color: #10316A !important;\n  padding: 10px 16px !important;\n  box-shadow: 0 2px 4px #00000014 !important;\n  border-radius: 6px !important;\n  opacity: 1 !important;\n}\n\n.test-modal-button-link {\n  display: inline !important;\n  margin-right: 8px;\n  color: #2E6EDF !important;\n  padding: 10px 16px !important;\n  opacity: 1 !important;\n}\n\n.test-modal-button-link:hover {\n  display: inline !important;\n  background-color: #DCE6FA !important;\n  margin-right: 8px;\n  color: #2E6EDF !important;\n  padding: 10px 16px !important;\n  opacity: 1 !important;\n}\n\n.test-modal-column-wrapper {\n  display: grid;\n  grid-template-columns: 51px auto;\n}\n\n.image-wrapper {\n  display: inline;\n}\n\n.column-description-wrapper { \n  display: inline;\n  margin-left: 13px; \n  vertical-align: top;\n}\n\n.column-description-title { \n  font-weight: 500;\n  font-size: 14px;\n  letter-spacing: 0.15px;\n  height: 22px;\n  color: #212121;\n}\n\n.column-description-text {\n\n  font-size: 12;\n  color: #212121;\n}\n\n.modal-cup-img {\n  width: 58px;\n  height: 58px;\n}\n\n.modal-cup-wrapper {\n  margin: 0 auto;\n  opacity: 1;\n  text-align: center;\n}\n\n.modal-illustration-img {\n  width: 255px;\n  height: 255px;\n}\n\n.modal-illustration-wrapper {\n  margin: 0 auto;\n  opacity: 1;\n  text-align: center;\n}\n\n.new-work-exp-time-wrapper {\n  position: absolute;\n  width: 175px;\n  height: 175px;\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  box-shadow: 0 0 20px #0000000A;\n  border-radius: 8px;\n  opacity: 1;\n  top: 40px;\n  /* left: 232px; */\n  right: 48px;\n  bottom: 44px\n}\n\n.new-work-exp-time-wrapper-new {\n  position: absolute;\n  width: 30%;\n  max-width: 294px;\n  /* height: 175px; */\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  box-shadow: 0 0 20px #0000000A;\n  border-radius: 6px;\n  opacity: 1;\n  top: 32px;\n  /* left: 232px; */\n  right: 32px;\n  bottom: 32px\n}\n\n.new-mcq-work-exp-title-small {\n  height: 26px;\n  text-align: left;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0.15px;\n  color: #FFFFFF !important;\n  opacity: 1;\n}\n\n.new-mcq-work-exp-title {\n  height: 37px;\n  text-align: left;\n  font-size: 28px;\n  font-weight: 500;\n  letter-spacing: 0;\n  color: #FFFFFF !important;\n  opacity: 1;\n}\n\n.new-mcq-work-exp-title-wrapper {\n  margin-top: 32px !important;\n  width: 70%;\n  max-width: 520px;\n}\n\n.shrink-title {\n  max-width: calc(100% - 175px - 54px);\n}\n\n@media only screen and (min-width: 1201px) and (max-width: 1310px) {\n  .new-mcq-work-exp-card .ant-card-body {\n    height: 350px\n  }\n  .new-mcq-work-exp-btn-wrapper {\n    margin-top: 0;\n    position: absolute;\n    bottom: 32px;\n  }\n  .new-mcq-description-wrapper-div {\n    width: 60%\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
